<template>
    <div class="form-body">
        <div class="row bottom-space">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="articleTitle"><span class="required">*</span>{{ $t("labels.title") }}</label>
                    <input type="text" class="form-control" v-model="article.title" @change="generateSlug">
                </div>
                 <div class="form-group">
                    <label for="articleSlug"><span class="required">*</span>{{ $t("labels.slug") }}</label>
                    <input type="text" class="form-control" v-model="article.slug">
                </div>
            </div>
            <div class="col-md-3">
                <div class="dropzone image-upload bottom-space">
                    <h5>
                        {{ $t("labels.featuredImage") }}
                        <span><strong>{{ $t('labels.maxImageSize') }}</strong><br>5 Mb</span> 
                        <span><strong>{{ $t('labels.allowedFormats') }}:</strong><br>{{ $store.state.allowedImageTypesSimple.toString().split(',').join(', ') }}</span>
                    </h5> <br>
                    <input type="file" id="featured" ref="featured" @change="getFeatured">
                </div>
            </div>
            <div class="col-md-3">
                <div class="row bottom-space selectedImage">
                    <div class="col-md-12" v-if="currentImage.name">
                    <figure>
                        <img :src="getUrl(currentImage)" alt="index">
                        <figcaption>{{ currentImage.name }}</figcaption>
                    </figure>
                    </div>
                    <div class="col-md-12" v-if="article.image && article.image.signed_url && !currentImage.name">
                        <figure>
                            <img :src="article.image.signed_url" alt="index">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <label for="projectinput4"><span class="required">*</span>{{ $t("labels.articleBody") }}</label>
                <div class="editor-2">
                    <ckeditor :editor="editor" v-model="article.body" :config="editorConfig"></ckeditor>
                </div>
            </div>
            <div class="col-md-4">
                <div class="custom-control custom-checkbox bottom-space">
                    <input type="checkbox" class="custom-control-input" id="published" v-model="article.published">
                    <label class="custom-control-label float-left" for="published">{{ $t("labels.published") }}</label>
                </div>
                <div class="form-group">
                    <label for="publishedDate">{{ $t("labels.publishedDate") }}</label>
                    <date-picker v-model="article.publishedAt" :lang="$i18n.locale" width="100%" type="datetime" appendToBody :format="$i18n.locale === 'en' ? 'DD/MM/YYYY hh:mm a' : 'DD/MM/YYYY HH:mm'" :minute-step="1" confirm></date-picker>
                </div>
            </div>
        </div>
        <div class="row bottom-space">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="metaTitle">{{ $t("labels.metaTitle") }}</label>
                    <input type="text" class="form-control" v-model="article.metaTitle">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="articleTitle">{{ $t("labels.metaDescription") }}</label>
                    <textarea name="metaDescription" id="metaDescription" class="form-control" v-model="article.metaDescription"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import slugify from 'slugify'
import moment from 'moment'

export default {
    props: ["article"],
    data() {
        return {
            keepInBounds: true,
            slug: '',
            currentImage: '',
            publishedDate: '',
            publishedTime: '',
            linkUrl: null,
            linkMenuIsActive: false,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: [
                        'bold',
                        'italic',
                        'link',
                        'bulletedList',
                        'mediaEmbed',
                        'undo',
                        'redo'
                    ]
                }
            }
        }
    },
    methods: {
        getFeatured() {
            this.article.image = this.$refs.featured.files[0]
            this.currentImage = this.$refs.featured.files[0]
        },
        setPublishedAt() {
            let date = this.publishedDate + ' ' + this.publishedTime
            this.article.publishedAt = new Date(date)
        },
        generateSlug() {
           if (!this.article.slug || this.article.slug.length === 0) { 
               this.article.slug = slugify(this.article.title, {
                   replacement: '-',
                   lower: true
               })
           }
        },
        getUrl(img) {
            return URL.createObjectURL(img)
        },
        showLinkMenu(attrs) {
            this.linkUrl = attrs.href
            this.linkMenuIsActive = true
            this.$nextTick(() => {
                this.$refs.linkInput.focus()
            })
        },
        hideLinkMenu() {
            this.linkUrl = null
            this.linkMenuIsActive = false
        },
        setLinkUrl(command, url) {
            command({ href: url })
            this.hideLinkMenu()
            this.editor.focus()
        }
    },
    mounted() {
        this.publishedDate = moment(new Date(this.article.publishedAt)).format('YYYY-MM-DD')
        this.publishedTime = moment(new Date(this.article.publishedAt)).format('HH:mm')
    }
}
</script>

<style lang="scss">
.dropzone {
        width: 100%;
        margin-top: 20px;
        text-align: center;
        background-color: #eee;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        min-height: 120px;
        outline: 2px dashed #eee;
        outline-offset: 5px;
        border: none;
        transition: all .5s ease;

        h5 {
          padding-top: 15px; 
          span {
            margin-top: 15px;
            display: block;
            font-size: 12px;

            strong {
              text-transform: uppercase;
            }
          }
        }

        &:hover {
            background-color: darken(#eee,10%);
            outline: 2px dashed darken(#eee,10%)
        }

        input {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0 !important;
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }
    .dropzone.avatar-upload {
      min-height: 258px;
    }
    .selectedImage {
        img {
            max-width: 100%;
        }
    }
    .ck-content { 
        min-height: 140px;
        margin-bottom: 25px; 
    }
</style>


